import { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'

export const useSetActiveConversationId = () => {
  const navigate = useNavigate()

  const setActiveConversationId = useCallback(
    (conversationId?: string) => {
      if (conversationId) {
        navigate(`/conversations/${conversationId}`)
      }
      else {
        navigate('/')
      }
    },
    [navigate],
  )

  return {
    setActiveConversationId,
  }
}
